<template>
  <section class="boilerRepair">
    <app-document>
      <h1 class="docHeader">Расценки на монтаж и ТО</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1kRjpwLmFPN3UgTxE_Txek0Ep6Mye-GKn/view?usp=sharing" target="_blank">
          <img class="docImg" src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
    </app-document>
    <div id="repairImage" style="text-align: center; width: 50%">
      <img src="../img/boiler-first.webp" alt="ремонт котла">
    </div>
  </section>
</template>

<script>
  import AppDocument from "@/components/AppDocument";

  export default {
    name: "AppRepairBoiler.vue",
    components: {AppDocument}
  }
</script>

<style scoped>

h1 {
  font-size: 2em;
  text-align: center;
  font-family: "Poppins", sans-serif !important;
}

h2 {
  text-align: center;
}

.boilerRepair {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 1600px;
}

img {
  width: 90%;
  height: auto;
}

@media (max-width: 900px) {
  img {
    width: 70%;
  }
}

@media (max-width: 800px) {
  .boilerRepair{
    flex-direction: column;
  }

  #repairImage {
    display: none;
  }

  img {
    width: 100%;
  }
}

</style>